/* eslint-disable no-unexpected-multiline */
import { useState, useEffect, SetStateAction, Dispatch } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { AxiosResponse } from 'axios'
import {
  Button,
  CheckBox,
  Col,
  Form,
  Grid,
  Input,
  InputFile,
  Row,
  Span,
  SuccessModal,
  ChipInput,
  AutoCompleteInput,
  TextArea,
  UnidadeGestoraFields,
  Picker,
  CurrencyInput,
  Modal,
  InputMask,
  AutoCompleteSearchTerm
} from 'components'
import SimpleCollapse from 'components/Collapse/SimpleCollapse'
import { LoadingIcon, MagnifyingGlassIcon } from 'components/Icons'
import { useDebounce, useEnvironment, useModal } from 'hooks'
import useAuth from 'hooks/useAuth'
import useLoading from 'hooks/useLoading'
import useToggle from 'hooks/useToggle'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import GenericServices from 'services/Generic/Generic'
import {
  ContractServices,
  ContractNGTServices,
  CreateContractNgt,
  ISaveFileRequest,
  ContractNgtResponse,
  ISubstitutosInputs,
  IContraparteSubstitutos,
  TxEmail,
  IContractForm,
  IHierarquiaProdutoResponse,
  IGrupoMercadoriaResponse
} from 'services/NGT/Contract'
import { CompanyServices } from 'services/NGT/Files'
import {
  ItemProductServices,
  ItemProdutoContratoResponseDto
} from 'services/NGT/ItemProduct'
import {
  FornecedorServices,
  IGetCsnUserByResponse,
  UserCsnService
} from 'services/Supplier/Users'
import { UnidadeGestoraServices } from 'services/Utils/UnidadeGestora'
import { COLORS, FONTS, FORMAT, SPACING, TYPOGRAPHY, PATTERNS } from 'utils'
import { convertBase64, preventDefaultOnEnter } from 'utils/functions'
import { ITypeUpload } from 'utils/types'

import AttachedFiles from '../AddNewContract/components/AttachedFiles'
import { SubContract } from '../SubContract/SubContract'
import * as yup from 'yup'
import { OLDYUP as YUP } from 'utils'
interface FormProps {
  setTab?: Dispatch<SetStateAction<number>>
  dtCadastro: Date
  flPrincipal?: boolean
  flSap: boolean
  costCenters: any
  sectors: any
  unidadesGestoras: any
  tipoCre: any
  grpMercadorias: IGrupoMercadoriaResponse[]
  hierarquiaProdutos: IHierarquiaProdutoResponse[]
  contractID: number
}

export const EditNoSapContract: React.FC<FormProps> = ({
  setTab,
  tipoCre,
  contractID,
  costCenters,
  dtCadastro,
  flSap,
  sectors,
  hierarquiaProdutos
}) => {
  const { setLoading, setMsgErro } = useLoading()
  const { user } = useAuth()

  const SCHEMA = {
    noSapContractForm: yup
      .object({
        CRE: yup
          .string()
          .typeError('CRE obrigatório')
          .required('CRE obrigatório'),
        setorId: yup
          .number()
          .notOneOf([0], 'Negócio obrigatório')
          .required('Negócio obrigatório')
          .typeError('Negócio Obrigatório'),
        cdContrato: yup.string().required('Contrato obrigatório'),
        cdGrupoMercadoria: yup
          .string()
          .required('Grupo Mercadoria obrigatório')
          .typeError('Grupo Mercadoria obrigatório'),
        cdHierarquiaProd: yup
          .string()
          .required('Hierarquia Produto obrigatório')
          .typeError('Hierarquia Produto obrigatório'),
        centroPlantaId: yup
          .number()
          .required('Centro Planta obrigatório')
          .typeError('Centro Planta obrigatório'),
        descGrupoMercadoria: yup
          .string()
          .required('Grupo Mercadoria obrigatório')
          .typeError('Grupo Mercadoria obrigatório'),
        emailsTrabalhistas: yup
          .array()
          .min(1, 'Informe pelo menos um E-mail')
          .test('invalid', 'Informe pelo menos um E-mail', (emails) => {
            return emails.some((_, index) => !flExclusao[index])
          }),
        empresaId: yup
          .number()
          .required('Empresa obrigatório')
          .typeError('Empresa obrigatório'),
        matriculaContraparte: yup.string().required('Contraparte obrigatório'),
        nmContraparte: yup.string().required('Contraparte obrigatório'),
        txAlerta: yup.string().when('flAlerta', {
          is: true,
          then: yup
            .string()
            .required(
              'Opção de alerta selecionada mas nenhuma justificativa inserida'
            )
        }),
        txDenuncia: yup.string().when('flDenuncia', {
          is: true,
          then: yup
            .string()
            .required(
              'Opção de denúncia selecionada mas nenhuma justificativa inserida'
            )
        }),
        txObjetoContrato: yup
          .string()
          .required('Objeto do Contrato obrigatório'),
        vlContratual: yup.string().required('Valor contratual obrigatório')
      })
      .concat(YUP.dateRange('dtVigenciaInicio', 'dtVigenciaFim').required)
      .concat(YUP.dateRange('dtVigInicoReal', 'dtVigFimReal').oneRequireAnother)
  }

  const {
    control,
    watch,
    handleSubmit,
    setValue,
    clearErrors,
    setError,
    getFieldState,
    getValues,
    formState: { errors }
  } = useForm({ resolver: yupResolver(SCHEMA.noSapContractForm) })

  const [empresas, setEmpresas] = useState<
    { nmEmpresa: string; idEmpresa: number }[]
  >([])
  const { showModal } = useModal()

  const [unidadeGestoraId, setUnidadeGestoraId] = useState<number>()
  const [unidadeCompradorId, setUnidadeCompradorId] = useState<string>()
  const [searchFile, setSearchFile] = useState<string>('')
  const [fileToDelete, setFileToDelete] = useState<number[]>([])
  const [arquivosSelecionados, setArquivosSelecionados] = useState<
    ITypeUpload[]
  >([])
  const [
    arquivosSelecionadosComFlagEncerrado,
    setArquivosSelecionadosComFlagEncerrado
  ] = useState<ITypeUpload[]>([])
  const [isQuarteirizacao, setIsQuarteirizacao] = useState<boolean>(false)
  const [contract, setContract] = useState<ContractNgtResponse>(null)
  const [subContract, setSubContract] = useState<any | null>(null)

  const [openModal, toggleModal] = useToggle()
  const [loadingEvidencia, setLoadingEvidencia] = useState<boolean>(false)
  const [successMsg, setSuccessMsg] = useState<string>('')
  const [isSuccess, setSuccess] = useState<boolean>(false)
  const [isError, toggleError] = useToggle()
  const [substituteErrorMsg, setSubstituteErrorMsg] = useState<string>('')
  const [flagUnidadeManual, setUnidadeManual] = useState<boolean>(false)
  const [flagContratoEncerrado, setFlagContratoEncerrado] =
    useState<boolean>(false)
  const [flagContratoEncerradoWasEnabled, setFlagContratoEncerradoWasEnabled] =
    useState<boolean>(false)
  const [flagSubcontrato, setFlagSubcontrato] = useState<boolean>(false)
  const [flagSocio, setFlagSocio] = useState<boolean>(false)
  const [flagDenuncia, setFlagDenuncia] = useState<boolean>(false)
  const [itemProdutoValue, setItemProdutoValue] = useState<string>()
  const [alterarItemProduto, setAlterarItemProduto] = useState<boolean>(false)
  const [itemProdutos, setItemProdutos] =
    useState<ItemProdutoContratoResponseDto[]>()
  const [flagAlerta, setFlagAlerta] = useState<boolean>(false)
  const [flagRecorrente, setFlagRecorrente] = useState<boolean>(false)
  const countTextArea = watch('txObjetoContrato')
  const [descHierarquiaProduto, setDescHierarquiaProduto] = useState<string>()
  const observacao = watch('txObservacao')
  const creNameValue = watch('CRE');

  const [selectedContraparte, setSelectedContraparte] = useState<any>()
  const [selectedMatriculaContraparte, setSelectedMatriculaContraparte] =
    useState<any>()
  const [selectedComprador, setSelectedComprador] = useState<any>()
  const [selectedCompradorObject, setSelectedCompradorObject] =
    useState<IGetCsnUserByResponse>()
  const [selectedMatriculaComprador, setSelectedMatriculaComprador] =
    useState<any>()
  const [contraparteId, setContraparteId] = useState(0)
  const [compradorId, setCompradorId] = useState<number>(null)
  const [isSub, setIsSub] = useState(false)
  const { website_url } = useEnvironment()
  const cdContrato = watch('cdContrato')
  const [semPreenchimento, setSemPreenchimento] = useState(false);

  const [substitutoList, setSubstitutoList] = useState<ISubstitutosInputs[]>([
    {
      emailSubstituto: '',
      idSubstituto: 0,
      matriculaSubstituto: '',
      nmSubstituto: '',
      ramalSubstituto: ''
    }
  ])

  const [matriculas, setMatriculas] = useState<{ label: string; value: any }[]>(
    [{ label: '', value: {} }]
  )
  const [analistas, setAnalistas] = useState<{ label: string; value: any }[]>([
    { label: '', value: {} }
  ])

  const [flExclusao, setFlExclusao] = useState<boolean[]>([])
  const matriculaContraparte = watch('matriculaContraparte')
  const [setorName, setSetorName] = useState('')

  const documento = watch('cnpj')
  const dtVigenciaFim = watch('dtVigenciaFim')
  const dtVigenciaInicio = watch('dtVigenciaInicio')
  const dtVigFimReal = watch('dtVigFimReal')
  const dtVigInicioReal = watch('dtVigInicoReal')

  const getEmpresas = () => {
    CompanyServices()
      .getAll()
      .then(({ data }) => {
        const empresas: { nmEmpresa: string; idEmpresa: number }[] = []
        data.map((contrato) => {
          empresas.push({
            idEmpresa: contrato.idEmpresa,
            nmEmpresa: contrato.txDescricao
          })
        })
        setEmpresas(empresas)
      })
      .catch(() => {
        // setMsgErro('Não foi possivel obter as Empresas.')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possivel obter as Empresas.',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const getUnidadeComprador = (idUnidadeComprador: number) => {
    setLoading('loading')
    UnidadeGestoraServices()
      .getById(idUnidadeComprador)
      .then((response) => {
        if (response?.status == 200) {
          handleChangeInput(response?.data?.numeroUnidade, 'unidadeComprador')
          setUnidadeCompradorId(response?.data?.numeroUnidade)
          setLoading('idle')
        } else {
          setLoading('idle')
          showModal({
            message: 'Ocorreu um problema ao buscar a unidade do comprador.',
            txtButtonCancel: '',
            txtButtonConfirm: 'Fechar',
            type: 'alert'
          })
        }
      })
    setLoading('idle')
  }

  const getItemProducts = (cdContrato: string) => {
    ItemProductServices()
      .GetItemProductsByCdContract(cdContrato)
      .then((response) => {
        if (response?.status == 200) {
          setItemProdutos(response?.data)
        } else {
          showModal({
            message: 'Ocorreu um problema ao buscar os itens do contrato.',
            txtButtonCancel: '',
            txtButtonConfirm: 'Fechar',
            type: 'alert'
          })
        }
      })
  }

  const getEvidencias = async (contratoPrincipalId: number | null) => {
    setLoadingEvidencia(true)
    let subContrato = 1
    if (contratoPrincipalId !== 0 && contratoPrincipalId !== null) {
      subContrato = 2
    } else {
      subContrato = 1
    }
    try {
      const response = await GenericServices.GetEvidencia(
        contractID,
        subContrato
      )

      // Se vier string vazia ou nada seta array vazia pra não quebrar
      setArquivosSelecionados(response?.data || [])

      setLoadingEvidencia(false)
    } catch (err: any) {
      setLoadingEvidencia(false)
      setMsgErro('Não foi possivel carregar evidencias.')
      setLoading('error')
    }
  }

  const handleChangeInput = (value, field) => setValue(field, value)

  const generateInputToken = (length = 10) => {
    let aleatoryString = ''

    const caracteres =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

    for (let i = 0; i < length; i++) {
      aleatoryString += caracteres.charAt(
        Math.floor(Math.random() * caracteres.length)
      )
    }

    return aleatoryString
  }

  const changeContractValues = (contract: ContractNgtResponse) => {
    handleChangeInput(contract.cdContrato, 'cdContrato')
    handleChangeInput(contract.cnpj?.trim(), 'cnpj')
    handleChangeInput(contract.nmFornecedor?.trim(), 'nmFornecedor')
    handleChangeInput(contract.nmEmpresa, 'empresaName')
    handleChangeInput(contract.nmCentro?.trim(), 'centroPlantaName')
    handleChangeInput(contract.empresaId, 'empresaId')
    handleChangeInput(contract.centroPlantaId, 'centroPlantaId')

    handleChangeInput(contract?.txObjetoContrato?.trim(), 'txObjetoContrato')
    handleChangeInput(contract?.nmCRE?.trim(), 'creName')
    handleChangeInput(contract?.tipoCreId, 'CRE')
    handleChangeInput(contract.txCno?.trim(), 'txCno')
    handleChangeInput(contract.flSocio, 'flSocio')

    setFlagContratoEncerrado(contract.flEncerrado)
    setFlagSubcontrato(contract.flSubcontrato)
    setFlagSocio(contract.flSocio)
    setFlagDenuncia(contract.flDenuncia)
    setFlagAlerta(contract.flAlerta)
    setFlagRecorrente(contract.flRecorrente)

    handleChangeInput(
      contract.dtVigInicoReal === '0001-01-01T00:00:00'
        ? null
        : contract.dtVigInicoReal,
      'dtVigInicoReal'
    )
    handleChangeInput(
      contract.dtVigFimReal === '0001-01-01T00:00:00'
        ? null
        : contract.dtVigFimReal,
      'dtVigFimReal'
    )

    handleChangeInput(
      contract.dtVigInicoReal === '0001-01-01T00:00:00'
        ? null
        : contract.dtVigInicoReal,
      'dtVigInicoReal'
    )

    handleChangeInput(
      contract.dtVigenciaInicio === '0001-01-01T00:00:00'
        ? null
        : moment(contract.dtVigenciaInicio),
      'dtVigenciaInicio'
    )
    handleChangeInput(
      contract.dtVigenciaFim === '0001-01-01T00:00:00'
        ? null
        : moment(contract.dtVigenciaFim),
      'dtVigenciaFim'
    )

    handleChangeInput(contract.vlContratual, 'vlContratual')
    handleChangeInput(contract.nmSetor, 'setorName')
    handleChangeInput(contract?.setorId, 'setorId')
    setSetorName(contract?.nmSetor)
    handleChangeInput(contract.txDenuncia?.trim(), 'txDenuncia')
    handleChangeInput(contract.txAlerta?.trim(), 'txAlerta')

    setUnidadeGestoraId(contract.unidadeGestoraId)
    setContraparteId(contract.contraparteUsuarioId)
    setSelectedMatriculaContraparte(contract.matriculaContraparte)
    setSelectedContraparte(contract.nmContraparte)
    handleChangeInput(contract.nmContraparte?.trim(), 'nmContraparte')
    handleChangeInput(contract.ramalContraparte?.trim(), 'ramalContraparte')
    handleChangeInput(contract.emailContraparte?.trim(), 'emailContraparte')
    handleChangeInput(
      contract.matriculaContraparte?.trim(),
      'matriculaContraparte'
    )

    handleChangeInput(contract.matriculaComprador?.trim(), 'matriculaComprador')
    handleChangeInput(contract.nmComprador?.trim(), 'nmComprador')
    handleChangeInput(contract.ramalComprador?.trim(), 'ramalComprador')
    handleChangeInput(contract.emailComprador?.trim(), 'emailComprador')
    setSelectedComprador(contract.nmComprador?.trim())
    setSelectedMatriculaComprador(contract.matriculaComprador?.trim())
    setCompradorId(contract.compradorUsuarioId)

    handleChangeInput(contract?.txObservacao, 'txObservacao')

    handleChangeInput(
      contract.txEmails?.map((email) => email.txEmail),
      'emailsTrabalhistas'
    )

    handleChangeInput(contract.nmUnidadeGestora?.trim(), 'nmUnidadeGestora')
    handleChangeInput(contract.unidadeGestoraId, 'idUnidadeGestora')

    handleChangeInput(contract.setorId, 'setorId')

    if (contract.contraparteSubstitutos?.length > 0) {
      setSubstitutoList(
        contract.contraparteSubstitutos.map(
          (substituto: IContraparteSubstitutos) => ({
            emailSubstituto: substituto.emailContraparteSub,
            idSubstituto: substituto.usuarioId,
            matriculaSubstituto: substituto.matriculaContraparteSub,
            nmSubstituto: substituto.nmContraparteSub,
            ramalSubstituto: substituto.ramalContraparteSub
          })
        )
      )
    }

    handleChangeInput(contract?.cdGrupoMercadoria, 'cdGrupoMercadoria')
    handleChangeInput(contract?.nmGrupoMercadoria, 'descGrupoMercadoria')
    handleChangeInput(contract?.nmHierarquiaProduto, 'descHierarquiaProduto')

    const foundHierarquia = hierarquiaProdutos.find(
      (hierarquiaProduto) =>
        hierarquiaProduto.idHierarquiaProduto == contract?.hierarquiaProdutoId
    )

    handleChangeInput(contract?.hierarquiaProdutoId, 'cdHierarquiaProd')
  }

  const getContractType = (): number => {
    if (PATTERNS.subcontract.test(contract?.cdContrato)) {
      return 2
    }

    if (PATTERNS.outsourcing.test(contract?.cdContrato)) {
      return 3
    }

    return 1
  }

  useEffect(() => {
    if (PATTERNS.outsourcing.test(cdContrato)) {
      setIsQuarteirizacao(true)
      setIsSub(true)
    }

    if (PATTERNS.subcontract.test(cdContrato)) {
      setIsSub(true)
    }
  }, [cdContrato])

  const getContract = () => {
    setLoading('loading')

    ContractServices()
      .GetContractNgtById(contractID)
      .then((response: AxiosResponse<ContractNgtResponse>) => {
        const { data: contract } = response

        contract.txEmails.map(() =>
          setFlExclusao((prevState) => [...prevState, false])
        )

        if (PATTERNS.outsourcing.test(contract.cdContrato)) {
          setIsQuarteirizacao(true)
          setIsSub(true)
        }
        if (
          PATTERNS.subcontract.test(contract.cdContrato) ||
          (PATTERNS.outsourcing.test(contract.cdContrato) &&
            contract?.contratoPrincipalId !== null)
        ) {
          setIsSub(true)
          getContratoPrincipal(contract)
        }
        getItemProducts(contract?.cdContrato)
        getUnidadeComprador(contract?.idUnidadeComprador)
        setItemProdutoValue(contract?.itemProdutoPrincipalId.toString())

        if (response.status === 200) {
          setUnidadeManual(contract.flUnidadeManual)
          setContract(contract)
          changeContractValues(contract)
          getEvidencias(contract.contratoPrincipalId)
        }

        setLoading('idle')
      })
      .catch((error) => {
        if (JSON.stringify(error === '{}')) return setLoading('idle')
        setLoading('error')
        // setMsgErro('Não foi possível obter os dados do contrato.')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter os dados do contrato.',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleFilterFilesTable = () => {
    if (searchFile !== '') {
      return arquivosSelecionados?.filter(
        (file: ITypeUpload) =>
          file?.dsDocumento?.toLowerCase().includes(searchFile.toLowerCase()) ||
          file?.dsExtensaoDoc?.toLowerCase().includes(searchFile.toLowerCase())
      )
    }

    return arquivosSelecionados
  }

  const getContratoPrincipal = (contract: ContractNgtResponse) => {
    setLoading('loading')

    ContractServices()
      .GetContractById(contract.contratoPrincipalId)
      .then((response: any) => {
        const { data: subContract } = response
        if (response.status === 200) {
          setSubContract(subContract)
        }

        setLoading('idle')
      })
      .catch(() => {
        setLoading('error')
        // setMsgErro('Não foi possível obter os dados do contrato.')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter os dados do contrato.',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleFileToDelete = (file: ITypeUpload) => {
    if (!flagContratoEncerrado) {
      if (file.anexoDocumentoId) {
        // Documento já está na base, insere na lista de ids a serem deletados
        setFileToDelete((prevState: number[]) => [
          ...prevState,
          file.anexoDocumentoId
        ])
      }
      // Documento temporário ainda não salvo, só remove do estado
      setArquivosSelecionados((prevState) =>
        prevState.filter((evidencia) => evidencia !== file)
      )
    } else {
      showModal({
        message:
          'Não é possivel deletar o anexo, pois a flag de contrato encerrado está ou foi ativado!',
        txtButtonCancel: '',
        txtButtonConfirm: 'Fechar',
        type: 'alert'
      })
    }
  }

  const handleDeleteFiles = async () => {
    if (fileToDelete.length <= 0) return Promise.resolve(true)

    const { contratoPrincipalId } = contract

    // Bate no endpoint de contrato ou sub
    const deleteEvidencia = (id: number) => {
      if (contratoPrincipalId !== 0 && contratoPrincipalId !== null) {
        return ContractNGTServices().deleteAnexarEvidenciaSubContrato(id)
      }
      return ContractNGTServices().deleteAnexarEvidenciaContrato(id)
    }

    const requests = fileToDelete.map((id: number) => deleteEvidencia(id))

    return Promise.all(requests)
      .then(() => true)
      .catch(() => {
        showModal({
          message:
            'Ocorreu um erro inesperado ao deletar a(s) evidência(s), por favor, verifique-as e tente novamente.',
          txtButtonCancel: '',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })

        return false
      })
      .finally(() => setLoading('idle'))
  }

  const handleChangeFile = async (files: File[]) => {
    if (files) {
      setLoading('loading')
      // try {
      for (let i = 0; i < files.length; i++) {
        const fileBase64 = (await convertBase64(files[i])) as string
        const newObj: ITypeUpload = {
          base64: FORMAT.file(fileBase64),
          documentoExternoGedId: String(generateInputToken(10)),
          dsDocumento: files[i].name,
          dsExtensaoDoc: files[i].type || 'application/octet-stream'
        }

        setArquivosSelecionados((prevState: ITypeUpload[]) => [
          ...prevState,
          newObj
        ])
      }
      setLoading('idle')
    }
  }

  const getDescHirarquiaProd = () => {
    const item = itemProdutos?.find(
      (itemProd) => itemProd?.idItemProduto == Number(itemProdutoValue)
    )
    setDescHierarquiaProduto(item?.codHierarquiaProduto)
  }

  useEffect(() => {
    getDescHirarquiaProd()
  }, [itemProdutoValue])

  const handleSubmitForm = async (form: IContractForm) => {
    const selectedUserFiles = arquivosSelecionados?.filter(
      (files: ITypeUpload) => files.base64
    )

    if (semPreenchimento) {
      showModal({
        hideButtonCancel: true,
        message: 'Por favor, altere o status do CRE para salvar o contrato.',
        titleModal: 'Atenção',
        txtButtonConfirm: 'OK',
        type: 'alert'
      })
      setLoading('idle');
      return
    }

    if (flagContratoEncerrado && arquivosSelecionados.length <= 0) {
      showModal({
        hideButtonCancel: true,
        message: 'Por favor, Anexe evidências que o contrato foi encerrado.',
        titleModal: 'Atenção',
        txtButtonConfirm: 'OK',
        type: 'alert'
      })
      setLoading('idle')
      return
    }

    const filesToSave: ISaveFileRequest[] =
      selectedUserFiles.length > 0
        ? arquivosSelecionados
          .filter((x) => !x.anexoDocumentoId)
          .map((file: ITypeUpload) => ({
            anexoDocumentoId: file.anexoDocumentoId || 0,
            descricao: file.dsExtensaoDoc,
            file: FORMAT.file(file.base64),
            nomeArquivo:
              file.dsDocumento != '' || file.dsDocumento != null
                ? file.dsDocumento
                : 'DOCUMENTO CONTRATO',

            nuAnoMesCompetencia: parseInt(FORMAT.formatYYYYMM(new Date())),
            tipoDocumentoId: getContractType(),
            tipoPendenciaId: 13,
            usuarioId: user.IdUsuario
          }))
        : []

    const idSubstitutoList: number[] | undefined =
      substitutoList[0].idSubstituto !== 0 && substitutoList[0] !== null
        ? substitutoList.map(
          (substituto: ISubstitutosInputs) => substituto.idSubstituto
        )
        : []

    const emailsToSend: TxEmail[] = [
      ...new Set(
        form.emailsTrabalhistas.map((email: string) => email.toLowerCase())
      )
    ].map(
      (email: string, index) =>
        flExclusao[index] !== null && {
          flExclusao: flExclusao[index],
          txEmail: email
        }
    )

    const updateContractObj: CreateContractNgt = {
      cdContrato: form.cdContrato,
      cdGrupoMercadoria: form.cdGrupoMercadoria,
      centroPlantaId: form.centroPlantaId,
      compradorUsuarioId: compradorId,
      contraparteUsuarioId: contraparteId,
      dtVigFimReal: form.dtVigFimReal,
      dtVigInicoReal: form.dtVigInicoReal,
      dtVigenciaFim: form.dtVigenciaFim,
      dtVigenciaInicio: form.dtVigenciaInicio,
      empresaId: form.empresaId,
      flAlerta: flagAlerta,
      flAtivo: contract.flAtivo,
      flDenuncia: flagDenuncia,
      flEncerrado: flagContratoEncerrado,
      flRecorrente: flagRecorrente,
      flSocio: flagSocio,
      flSubcontrato: form.flSubcontrato || false,
      fornecedorId: contract.fornecedorId,
      hierarquiaId: parseInt(form.cdHierarquiaProd),
      idContrato: Number(contractID),
      idUnidGestora: form.idUnidadeGestora,
      itemProdutoId: Number(itemProdutoValue),
      listAnexarDocs: filesToSave,
      listContraparteSubstituto: idSubstitutoList.filter(
        (substituto) => substituto != null
      ),
      setorContratoId: form.setorId,
      tipoCreId: parseInt(form.CRE),
      txAlerta: form.txAlerta,
      txCno: form.txCno,
      txDenuncia: form.txDenuncia,
      txEmail: emailsToSend || [],
      txObjetoContrato: form.txObjetoContrato,
      txObservacao: form.txObservacao,
      url: website_url,
      vlContratual: parseFloat(form.vlContratual)
    }

    setLoading('loading')
    ContractNGTServices()
      .noSapUpdate(updateContractObj)
      .then((response: AxiosResponse) => {
        handleDeleteFiles().then(() => {
          if (response.status === 200) {
            showModal({
              hideButtonCancel: true,
              message: response.data.mensagem || 'Contrato salvo com sucesso.',
              txtButtonConfirm: 'Fechar',
              type: 'success'
            })
          }

          setTab(0)
          setLoading('idle')
        })
      })
      .catch((error) => {
        setLoading('idle')

        const errorMessage =
          error?.response?.data?.mensagem ||
          error?.response?.data?.detalhe ||
          error?.response?.data?.title ||
          error?.message ||
          'Não foi possivel salvar o Contrato'

        showModal({
          hideButtonCancel: true,
          message: errorMessage,
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })

  }

  const handleSelectedContraparte = (value: IGetCsnUserByResponse) => {
    setSelectedContraparte(value.usuario?.nmUsuario)
    setSelectedMatriculaContraparte(value.nmMatricula)
    setValue('matriculaContraparte', value.nmMatricula)
    setValue('nmContraparte', value.usuario?.nmUsuario)
    setValue('ramalContraparte', value.usuario?.nuRamal)
    setValue('emailContraparte', value.usuario?.txEmail)
    setValue('idUnidadeGestora', value?.idUnidGestora)
    setUnidadeGestoraId(value?.idUnidGestora)
    setContraparteId(value.usuario?.idUsuario)

    const _matriculaContraparte = watch('matriculaContraparte')
    const _nmContraparte = watch('nmContraparte')

    if (_matriculaContraparte && _nmContraparte) {
      clearErrors('matriculaContraparte')
      clearErrors('nmContraparte')
    }
  }

  const handleSelectedComprador = (value: IGetCsnUserByResponse) => {
    setSelectedComprador(value.usuario?.nmUsuario)
    setSelectedMatriculaComprador(value?.nmMatricula)
    getUnidadeComprador(value?.idUnidGestora)
    setValue('matriculaComprador', value?.nmMatricula)
    setValue('nmCoprador', value.usuario?.nmUsuario)
    setValue('ramalComprador', value.usuario?.nuRamal)
    setValue('emailComprador', value.usuario?.txEmail)
    setCompradorId(value.usuario?.idUsuario)
    setSelectedCompradorObject(value)
  }

  const handleSearchMatricula = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setMatriculas([])
    setLoading('loading')
    if (event.target.value === '') {
      setLoading('idle')
      return
    }
    UserCsnService()
      .getByMatricula(event.target.value)
      .then((response: AxiosResponse<IGetCsnUserByResponse[]>) => {
        const selectedFieldOptions = response.data.map(
          (analista: IGetCsnUserByResponse) => ({
            label: analista.nmMatricula,
            value: analista
          })
        )

        setMatriculas(selectedFieldOptions)
        setLoading('idle')
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter os dados da matrícula.',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleSearchAnalista = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAnalistas([])
    setLoading('loading')
    if (event.target.value === '') {
      setLoading('idle')
      return
    }
    UserCsnService()
      .getByNome(event.target.value)
      .then((response: AxiosResponse<IGetCsnUserByResponse[]>) => {
        const selectedFieldOptions = response.data.map(
          (analista: IGetCsnUserByResponse) => ({
            label: analista.usuario.nmUsuario,
            value: analista
          })
        )

        setAnalistas(selectedFieldOptions)
        setLoading('idle')
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível encontrar os dados do Analista.',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const addSubstituto = () => {
    setSubstitutoList([
      ...substitutoList,
      {
        emailSubstituto: '',
        idSubstituto: 0,
        matriculaSubstituto: '',
        nmSubstituto: '',
        ramalSubstituto: ''
      }
    ])
  }

  const removeSubstituto = (position: number) => {
    if (substitutoList?.length == 1) {
      setSubstitutoList([
        {
          emailSubstituto: '',
          idSubstituto: 0,
          matriculaSubstituto: '',
          nmSubstituto: '',
          ramalSubstituto: ''
        }
      ])
    } else {
      setSubstitutoList([
        ...substitutoList.filter((_, index: number) => index !== position)
      ])
    }
  }

  const handleSelectedSubstituto = (
    substituto: IGetCsnUserByResponse,
    index: number
  ) => {
    substitutoList[index].idSubstituto = substituto?.usuarioId
    substitutoList[index].matriculaSubstituto = substituto?.nmMatricula
    substitutoList[index].nmSubstituto = substituto.usuario?.nmUsuario
    substitutoList[index].ramalSubstituto = substituto.usuario?.nuRamal
    substitutoList[index].emailSubstituto = substituto.usuario?.txEmail
    setSubstitutoList([...substitutoList])
  }

  const handleEncerrarContratoFlag = (event) => {
    if (event.target.checked === false) {
      setFlagContratoEncerrado(false)
      setFlagContratoEncerradoWasEnabled(false)
      setArquivosSelecionadosComFlagEncerrado([])
    } else {
      handleChangeInput(event.target.checked, 'flEncerrado')
      setFlagContratoEncerrado(event.target.checked)
      setTimeout(() => {
        if (event.target.checked) {
          showModal({
            hideButtonCancel: true,
            message:
              'Flag de contrato encerrado habilitado! Por favor insira um anexo evidenciando o encerramento',
            txtButtonConfirm: 'Fechar',
            type: 'alert'
          })
          setFlagContratoEncerradoWasEnabled(event.target.checked)
          setArquivosSelecionadosComFlagEncerrado(arquivosSelecionados)
        }
      }, 1000)
    }
  }

  const handleDisabledSalvarButton = () => {
    if (getFieldState('emailsTrabalhistas').invalid) return true

    if (flagContratoEncerradoWasEnabled) {
      const isFileListEquals =
        arquivosSelecionados === arquivosSelecionadosComFlagEncerrado
          ? true
          : false
      const isArquivosSelecionadosLenghtBigger =
        arquivosSelecionados.length >
          arquivosSelecionadosComFlagEncerrado.length
          ? true
          : false
      if (isArquivosSelecionadosLenghtBigger && !isFileListEquals) {
        return false
      } else {
        return true
      }
    }
    return false
  }

  const handleFimVigenciaChange = () => {
    setTimeout(() => {
      if (contract) {
        const dtVigenciaFimInicialString = contract?.dtVigenciaFim
          .toString()
          .slice(0, 10)
        const dtVigenciaAlterada = new Date(watch('dtVigenciaFim'))
        const dtVigenciaAlteradaString = new Date(watch('dtVigenciaFim'))
          .toISOString()
          .slice(0, 10)
        const minimumDateAllowed = new Date('2001-01-01')

        if (
          dtVigenciaFimInicialString !== dtVigenciaAlteradaString &&
          dtVigenciaAlterada > minimumDateAllowed
        ) {
          setFlagContratoEncerrado(false)
          setFlagContratoEncerradoWasEnabled(false)
        }
      }
    }, 3000)
  }

  const enviarEmail = () => {
    setLoading('loading')

    FornecedorServices()
      .supplierEmailValidation({
        idContrato: contract.idContrato,
        url: website_url
      })
      .then(() => {
        setLoading('idle')
        showModal({
          handleConfirm: () => {
            // getContract()
            setTab(0)
          },
          hideButtonCancel: true,
          message: 'E-mail enviado com sucesso!',
          txtButtonConfirm: 'Fechar',
          type: 'success'
        })
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          handleConfirm: () => {
            // getContract()
            setTab(0)
          },
          hideButtonCancel: true,
          message: 'Erro ao enviar e-mail',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const verifyValueCre = (creNameValue) => {
    if (creNameValue == 9)
      setSemPreenchimento(true);
    else setSemPreenchimento(false);
  }

  useEffect(() => {
    verifyValueCre(creNameValue);
  }, [creNameValue])


  useEffect(() => {
    getEmpresas()
    getContract()
    getDescHirarquiaProd()
  }, [])

  useEffect(() => {
    if (arquivosSelecionados) {
      handleFilterFilesTable()
    }
  }, [arquivosSelecionados])

  return (
    <>
      <Modal openModal={openModal}>
        <SubContract
          idUnidadeGestora={unidadeGestoraId}
          tipoCre={tipoCre}
          contrato={contract}
          cdHierarquiaProd={descHierarquiaProduto}
          handleCloseModal={() => toggleModal()}
          enviarEmailHandle={enviarEmail}
          dtVigenciaFim={dtVigenciaFim}
          dtVigenciaInicio={dtVigenciaInicio}
          dtVigenciaRealFim={dtVigFimReal}
          dtVigenciaRealInicio={dtVigInicioReal}
          unidadeComprador={unidadeCompradorId}
          selectedComprador={selectedCompradorObject}
        />
      </Modal>

      <Form
        onSubmit={handleSubmit(handleSubmitForm)}
        onKeyDown={preventDefaultOnEnter}
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <SimpleCollapse title="INFORMAÇÕES GERAIS">
          <Row
            marginTop={SPACING.spacing10}
            marginBottom={SPACING.spacing20}
            justifyContent="space-between"
          >
            <Row marginTop={SPACING.spacing10}>
              <Span
                text="Data Cadastro:"
                fontSize={TYPOGRAPHY.bodySize16}
                fontWeight={FONTS.bold}
                marginRight={SPACING.spacing5}
              />
              <Span
                text={FORMAT.formatDDMMYYYY(dtCadastro)}
                color={COLORS.blueFonts}
                fontSize={TYPOGRAPHY.bodySize16}
                fontWeight={FONTS.bold}
              />
            </Row>
            <Row justifyContent="flex-end">
              <CheckBox
                marginRight={SPACING.spacing15}
                label="Importado pelo SAP"
                checked={flSap}
                disabled
              />
              {!isQuarteirizacao && (
                <Button
                  text="Gerar Subcontrato"
                  onClick={() =>
                    contract?.unidadeGestoraId !== 0 &&
                      contract?.nmUnidadeGestora !== ''
                      ? toggleModal()
                      : null
                  }
                />
              )}
            </Row>
          </Row>
          <Grid
            gridCols="1fr 1.2fr 2.4fr 1.70fr 1.70fr"
            gridGap={`0 ${SPACING.spacing10}`}
            alignItems="flex-end"
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              control={control}
              errors={errors}
              label="Contrato"
              placeholder="Nº"
              formValue="cdContrato"
              maxLength={15}
              disabled
            />

            <Input
              control={control}
              errors={errors}
              label="CPF/CNPJ/Cód.Fornecedor"
              placeholder="Nº"
              formValue="cnpj"
              mask={
                documento && documento.length > 9
                  ? ['###.###.###-##', '##.###.###/####-##']
                  : ['#########']
              }
              disabled
            //inputIcon={<MagnifyingGlassIcon />}
            //onClickIcon={() => getSupplierByCnpj(documento)}
            />

            <Input
              control={control}
              errors={errors}
              label="Fornecedor"
              placeholder="Nome do fornecedor"
              formValue="nmFornecedor"
              disabled
            />
            <AutoCompleteSearchTerm
              control={control}
              errors={errors}
              // value={empresaName}
              label="Empresa"
              formValue="empresaId"
              options={empresas || []}
              optionLabel="nmEmpresa"
              optionValue="idEmpresa"
            />
            <AutoCompleteSearchTerm
              control={control}
              errors={errors}
              // value={centroPlantaName}
              label="Centro Planta"
              formValue="centroPlantaId"
              options={costCenters || []}
              optionLabel="txDescricao"
              optionValue="idCentroPlanta"
              defaultValue={contract?.centroPlantaId || ''}
            />
            {/* <AutoCompleteInput */}
            {/*   marginTop="0.25rem" */}
            {/*   value={centroPlantaName} */}
            {/*   label="Centro Planta" */}
            {/*   formValue="centroPlantaId" */}
            {/*   options={costCenters} */}
            {/*   key="CentroPlantaInput" */}
            {/*   optionValue="txDescricao" */}
            {/*   valueName="idCentroPlanta" */}
            {/* /> */}
          </Grid>
          <Grid
            gridCols="4fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <TextArea
              count={countTextArea?.length || 0}
              label="Objeto do contrato"
              control={control}
              errors={errors}
              formValue="txObjetoContrato"
              limitCount={150}
              maxLength={150}
              value={contract?.txObjetoContrato || ''}
            />
          </Grid>
          <Grid
            gridCols="3fr 3fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <AutoCompleteSearchTerm
              control={control}
              errors={errors}
              label="CRE"
              formValue="CRE"
              options={tipoCre || []}
              optionLabel="txDenominacao"
              optionValue="idTipoCre"
              defaultValue={contract?.nmCRE || ''}
            />
            <Input
              control={control}
              errors={errors}
              mask={['##.###.#####/##']}
              label="CNO ( Cadastro Nacional de Obras )"
              placeholder="CNO"
              formValue="txCno"
              defaultValue={contract?.txCno || ''}
            />
          </Grid>
          <Grid
            gridCols="1fr 1fr 1fr 1fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Picker
              defaultValue={new Date()}
              label="Início Vigência Contrato"
              formValue="dtVigenciaInicio"
              control={control}
              id="IniVigContrato"
              maxDate={dtVigenciaFim}
              errors={errors}
            />
            <Picker
              defaultValue={new Date()}
              label="Fim Vigência Contrato"
              formValue="dtVigenciaFim"
              id="FimVigContrato"
              minDate={dtVigenciaInicio}
              control={control}
              errors={errors}
              onChange={
                handleFimVigenciaChange() as unknown as (_event: any) => void
              }
            />
            <Picker
              defaultValue={null}
              label="Início Vigência Real"
              formValue="dtVigInicoReal"
              maxDate={dtVigFimReal}
              errors={errors}
              control={control}
            />
            <Picker
              defaultValue={null}
              label="Fim Vigência Real"
              formValue="dtVigFimReal"
              minDate={dtVigInicioReal}
              errors={errors}
              control={control}
            />
          </Grid>

          <Grid
            gridCols="0.765fr 0.765fr 0.5fr 0.5fr 0.5fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
            alignItems="flex-end"
          >
            <CurrencyInput
              control={control}
              errors={errors}
              label="Valor Contratual"
              placeholder="Valor"
              formValue="vlContratual"
              maxLength={16}
            />

            <AutoCompleteSearchTerm
              defaultValue={''}
              value={setorName}
              options={sectors}
              optionLabel="dsSetorContrato"
              label="Negócio"
              control={control}
              errors={errors}
              formValue="setorId"
              optionValue="idSetorContrato"
            />

            <Col>
              <Span text="Tipo" />
              <CheckBox
                checked={flagRecorrente}
                label="Recorrente"
                onClick={(event) => {
                  handleChangeInput(event.target.checked, 'flRecorrente')
                  setFlagRecorrente(event.target.checked)
                }}
              />
            </Col>
            <Col>
              <Span text="Contrato" />
              <CheckBox
                checked={flagContratoEncerrado}
                label="Encerrado"
                onChange={(event) => {
                  handleEncerrarContratoFlag(event)
                }}
              />
            </Col>
            <CheckBox
              marginTop="1rem"
              checked={flagSocio}
              label="Sócio"
              onClick={(event) => {
                handleChangeInput(event.target.checked, 'flSocio')
                setFlagSocio(event.target.checked)
              }}
            />
          </Grid>

          <Span fontSize="1em" text="Notificação" />
          <Grid
            gridCols={
              !isSub ? '0.8fr 0.8fr 0.8fr 2fr 2fr' : '0.8fr 0.8fr 2fr 2fr'
            }
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <CheckBox
              checked={flagDenuncia}
              label="Denúncia"
              onClick={(event) => {
                handleChangeInput(event.target.checked, 'flDenuncia')
                setFlagDenuncia(event.target.checked)
                if (!event.target.checked) {
                  handleChangeInput('', 'txDenuncia')
                }
              }}
            />
            <CheckBox
              checked={flagAlerta}
              label="Alerta"
              onClick={(event) => {
                handleChangeInput(event.target.checked, 'flAlerta')
                setFlagAlerta(event.target.checked)
                if (!event.target.checked) {
                  handleChangeInput('', 'txAlerta')
                }
              }}
            />
            {!isSub && (
              <CheckBox
                checked={flagSubcontrato}
                label="Solicitação Subcontrato"
                onClick={(event) => {
                  handleChangeInput(event.target.checked, 'flSubcontrato')
                  setFlagSubcontrato(event.target.checked)
                }}
              //disabled
              />
            )}
            <Input
              maxLength={1000}
              control={control}
              errors={errors}
              label="Denúncia"
              placeholder="Justifique"
              formValue="txDenuncia"
              disabled={!flagDenuncia}
            />
            <Input
              maxLength={1000}
              control={control}
              errors={errors}
              label="Alerta"
              placeholder="Justifique"
              formValue="txAlerta"
              disabled={!flagAlerta}
            />
          </Grid>
          <Grid
            gridCols="1.1fr 2fr 1fr 2.9fr 0.5fr 0.5fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <AutoCompleteInput
              errors={errors}
              name="matriculaContraparte"
              onChangeText={useDebounce(handleSearchMatricula, 600)}
              value={selectedMatriculaContraparte || null}
              options={
                matriculas.filter((m) =>
                  substitutoList.every(
                    (sub) => sub?.matriculaSubstituto !== m.label
                  )
                ) || []
              }
              formValue="matriculaContraparte"
              optionValue="label"
              label="Matrícula Contraparte"
              onChange={(selectedValue, value) => {
                handleSelectedContraparte(value)
              }}
              valueName="value"
              noFilter
              marginTop="0.25rem"
              required
            />
            <AutoCompleteInput
              errors={errors}
              name="nmContraparte"
              onChangeText={useDebounce(handleSearchAnalista, 600)}
              value={selectedContraparte}
              options={analistas}
              optionValue="label"
              label="Nome do Contraparte"
              formValue="nmContraparte"
              onChange={(selectedValue, value) => {
                handleSelectedContraparte(value)
              }}
              valueName="value"
              noFilter
              marginTop="0.25rem"
              defaultValue={contract?.nmContraparte || ''}
            />

            <Input
              disabled
              control={control}
              errors={errors}
              label="Ramal"
              formValue="ramalContraparte"
              placeholder="Nº"
              required
              min={0}
            />
            <Input
              disabled
              type="email"
              control={control}
              errors={errors}
              label="E-mail"
              formValue="emailContraparte"
              placeholder="Endereço de E-mail"
              required
            />
          </Grid>

          {substitutoList.length === 0 && addSubstituto}
          {substitutoList.map((substitutoItem, index) => (
            <>
              <Grid
                key={index}
                gridCols="1.1fr 2fr 1fr 2.9fr 0.5fr 0.5fr"
                gridGap={`0 ${SPACING.spacing10}`}
                margin={`0 0 ${SPACING.spacing30} 0`}
              >
                <AutoCompleteInput
                  name="matriculaSubstituto"
                  onChangeText={handleSearchMatricula}
                  value={substitutoItem?.matriculaSubstituto}
                  options={
                    matriculas.filter(
                      (m) =>
                        m.label !== matriculaContraparte &&
                        substitutoList.every(
                          (sub) => sub?.matriculaSubstituto !== m.label
                        )
                    ) || []
                  }
                  optionValue="label"
                  label="Matrícula Substituto"
                  onChange={(selectedValue, value) => {
                    handleSelectedSubstituto(value, index)
                  }}
                  valueName="value"
                  noFilter
                  marginTop="0.25rem"
                  defaultValue={substitutoItem?.matriculaSubstituto || ''}
                />
                <AutoCompleteInput
                  name="nmSubstituto"
                  onChangeText={handleSearchAnalista}
                  value={substitutoItem?.nmSubstituto}
                  options={analistas}
                  optionValue="label"
                  label="Nome do Substituto"
                  onChange={(selectedValue, value) => {
                    handleSelectedSubstituto(value, index)
                  }}
                  valueName="value"
                  noFilter
                  marginTop="0.25rem"
                  defaultValue={substitutoItem?.nmSubstituto || ''}
                />
                <Input
                  disabled
                  label="Ramal"
                  value={substitutoItem?.ramalSubstituto}
                  //formValue="ramalSubstituto"
                  placeholder="Nº"
                  min={0}
                />
                <Input
                  disabled
                  type="email"
                  label="E-mail"
                  value={substitutoItem?.emailSubstituto}
                  //formValue="emailSubstituto"
                  placeholder="Endereço de E-mail"
                />
                <Button
                  text="+"
                  onClick={addSubstituto}
                  marginTop={SPACING.spacing10}
                />
                {
                  <Button
                    text="-"
                    onClick={() => removeSubstituto(index)}
                    marginTop={SPACING.spacing10}
                  />
                }
              </Grid>
            </>
          ))}

          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <Grid
              gridCols="1.1fr 2fr 1fr 2.9fr 1.1fr"
              gridGap={`0 ${SPACING.spacing10}`}
              margin={`0 0 ${SPACING.spacing10} 0`}
            >
              <AutoCompleteInput
                name="matriculaComprador"
                onChangeText={useDebounce(handleSearchMatricula, 600)}
                value={selectedMatriculaComprador || null}
                options={matriculas || []}
                optionValue="label"
                label="Matrícula Comprador"
                onChange={(selectedValue, value) => {
                  handleSelectedComprador(value);
                }}
                valueName="value"
                noFilter
                marginTop="0.25rem"
                defaultValue={selectedMatriculaComprador || ''}
              />
              <AutoCompleteInput
                name="nmComprador"
                onChangeText={useDebounce(handleSearchAnalista, 600)}
                value={selectedComprador}
                options={analistas}
                optionValue="label"
                label="Nome do Comprador"
                onChange={(selectedValue, value) => {
                  handleSelectedComprador(value);
                }}
                valueName="value"
                noFilter
                marginTop="0.25rem"
                defaultValue={selectedComprador || ''}
              />
              <Input
                control={control}
                label="Ramal"
                placeholder="Nº"
                disabled
                formValue="ramalComprador"
                min={0}
              />
              <Input
                type="email"
                control={control}
                label="E-mail"
                placeholder="Endereço de E-mail"
                formValue="emailComprador"
                disabled
              />
              <Input
                control={control}
                type="number"
                label="Unidade do Comprador"
                placeholder="Unidade do Comprador"
                formValue="unidadeComprador"
                min={0}
                disabled
              />
            </Grid>

            <div style={{ display: 'flex', justifyContent: 'flex-start', margin: '16px 0' }}>

              <CheckBox
                checked={flagUnidadeManual}
                label="Unidade Manual"
                disabled={true}
              />
            </div>

            <UnidadeGestoraFields
              gridCols={{
                Diretoria: 6,
                DiretoriaExecutiva: 6,
                Gerencia: 6,
                GerenciaGeral: 6,
                Unidade: 12,
                spacing: 1
              }}
              renderUnidadeSelect
              defaultValue={unidadeGestoraId}
              disableFields={[
                'DiretoriaExecutiva',
                'Diretoria',
                'GerenciaGeral',
                'Gerencia'
              ]}
              control={control}
              formValue="idUnidadeGestora"
              disabled={isSub}
            />
          </div>

          {
            <Row justifyContent={'space-between'} alignItems="center">
              {itemProdutos ? (
                itemProdutos.map((item) =>
                  alterarItemProduto ? (
                    <Grid
                      width="93%"
                      gridCols={`0.1fr 0.4fr 0.3fr 0.9fr 0.9fr 0.9fr 0.8fr`}
                      gridGap={`0 ${SPACING.spacing20}`}
                      margin={`${SPACING.spacing30} 0 ${SPACING.spacing30} 0`}
                    >
                      <CheckBox
                        checked={
                          itemProdutoValue == item?.idItemProduto?.toString()
                        }
                        onClick={() => {
                          handleChangeInput(
                            item?.centroPlantaId,
                            'centroPlantaId'
                          )
                          handleChangeInput(
                            item?.descCentroPlanta,
                            'centroPlantaName'
                          )
                          setItemProdutoValue(item?.idItemProduto?.toString())
                        }}
                      />
                      <Input
                        label="Item"
                        placeholder="N° Item Prod."
                        value={item.cdOrdemItem}
                        disabled
                      />
                      <Input
                        label="Cód. Grupo Mercadoria"
                        placeholder="Cód."
                        value={item.codGrupoMercadoria}
                        disabled
                      />
                      <Input
                        label="Descrição do Grupo Mercadoria"
                        placeholder="Descrição"
                        value={item.descGrupoMercadoria}
                        disabled
                      />
                      <Input
                        label="Cód. Hierarquia Produto"
                        placeholder="Cód."
                        disabled
                        value={item.codHierarquiaProduto}
                      />
                      <Input
                        label="Descrição Hierarquia Produto"
                        placeholder="Descrição"
                        value={item.descHierarquiaProduto}
                        disabled
                      />
                      <AutoCompleteInput
                        marginTop="0.25rem"
                        defaultValue={item.descCentroPlanta}
                        options={costCenters}
                        optionValue="txDescricao"
                        label="Centro Planta"
                        placeholder="cENTRO PLANTA"
                        control={control}
                        disabled
                        formValue="centroPlantaId"
                        valueName="idCentroPlanta"
                      />
                    </Grid>
                  ) : (
                    item?.idItemProduto?.toString() == itemProdutoValue && (
                      <Grid
                        width="93%"
                        gridCols="0.1fr 0.4fr 0.3fr 0.9fr 0.9fr 0.9fr"
                        gridGap={`0 ${SPACING.spacing20}`}
                        margin={`${SPACING.spacing30} 0 ${SPACING.spacing30} 0`}
                      >
                        <CheckBox
                          checked={
                            itemProdutoValue == item?.idItemProduto?.toString()
                          }
                          onClick={() => {
                            setItemProdutoValue(item?.idItemProduto?.toString())
                          }}
                        />
                        <Input
                          label="Item"
                          placeholder="N° Item Prod."
                          value={item.cdOrdemItem}
                          disabled
                        />
                        <Input
                          label="Cód. Grupo Mercadoria"
                          placeholder="Cód."
                          value={item.codGrupoMercadoria}
                          disabled
                        />
                        <Input
                          label="Descrição do Grupo Mercadoria"
                          placeholder="Descrição"
                          value={item.descGrupoMercadoria}
                          disabled
                        />
                        <Input
                          label="Cód. Hierarquia Produto"
                          placeholder="Cód."
                          disabled
                          value={item.codHierarquiaProduto}
                        />
                        <Input
                          label="Descrição Hierarquia Produto"
                          placeholder="Descrição"
                          value={item.descHierarquiaProduto}
                          disabled
                        />
                      </Grid>
                    )
                  )
                )
              ) : (
                <LoadingIcon
                  colorIcon={COLORS.blueFonts}
                  marginTop={SPACING.spacing20}
                />
              )}
              <Grid
                gridCols="100%"
                margin={`${SPACING.spacing30} 0 ${SPACING.spacing30} 0`}
              >
                <Button
                  text={alterarItemProduto ? 'Salvar' : 'Alterar'}
                  onClick={() =>
                    itemProdutos && itemProdutos.length > 1
                      ? setAlterarItemProduto(!alterarItemProduto)
                      : showModal({
                        hideButtonCancel: true,
                        message: 'Não encontramos mais de um item produto.',
                        titleModal: 'Atenção',
                        txtButtonConfirm: 'OK',
                        type: 'alert'
                      })
                  }
                  marginLeft={SPACING.spacing10}
                />
              </Grid>
            </Row>
          }

          <Grid
            gridCols="8fr "
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <ChipInput
              mensagem="Pressione espaço para selecionar um E-mail"
              errors={errors}
              enableInsertOnEnter
              control={control}
              onKeyUp={(event) => {
                const email = event?.target?.value?.trim() // Mova esta linha para fora do bloco else
                if (event?.target?.value?.trim()) {
                  // Verifique se há um email antes de prosseguir
                  const emailsTrabalhistas = getValues('emailsTrabalhistas')
                  const emailDuplicado = emailsTrabalhistas.includes(email)
                  setError('emailsTrabalhistas', {
                    message:
                      'E-mail não confirmado! Pressione ENTER caso queira incluí-lo.',
                    type: 'custom'
                  })
                  if (emailDuplicado) {
                    setError('emailsTrabalhistas', {
                      message:
                        'E-mail já cadastrado neste contrato, por favor, digite outro',
                      type: 'custom'
                    })
                  }
                  return
                }
                clearErrors('emailsTrabalhistas')
              }}
              label="E-mail documentação trabalhista"
              formValue="emailsTrabalhistas"
              placeholder=""
              only="email"
              flExclusao={flExclusao}
              setFlExclusao={setFlExclusao}
            />
          </Grid>
          <Grid
            gridCols="8fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing5} 0`}
          >
            <InputMask
              maxLength={500}
              control={control}
              label="Observação"
              defaultValue={observacao}
              formValue="txObservacao"
              placeholder="Observação"
            //multiline
            />
          </Grid>
        </SimpleCollapse>

        {isSub && (
          <SimpleCollapse title="DADOS DO CONTRATO PRINCIPAL">
            <Grid
              gridCols="1fr 3.5fr 3.5fr"
              gridGap={`0 ${SPACING.spacing10}`}
              margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
            >
              <Input
                label="Contrato"
                placeholder="Nº"
                value={subContract?.cdContrato || null}
                disabled
              />
              <Input
                value={subContract?.nmFornecedor || null}
                label="Fornecedor"
                placeholder="Nome do Fornecedor"
                disabled
              />

              <Input
                value={subContract?.txObservacao || null}
                disabled
                label="Observação"
                placeholder="Observação"
                multiline
              />
            </Grid>
            <Grid
              gridCols="2fr"
              gridGap={`0 ${SPACING.spacing10}`}
              margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
            >
              <TextArea
                value={subContract?.txObjetoContrato || null}
                disabled
                label="Objeto do contrato"
                placeholder="Objeto do contrato"
                count={countTextArea?.length || 0}
                limitCount={150}
                maxLength={150}
              />
            </Grid>
          </SimpleCollapse>
        )}

        {loadingEvidencia ? (
          <LoadingIcon
            colorIcon={COLORS.blueFonts}
            marginTop={SPACING.spacing20}
          />
        ) : (
          <SimpleCollapse title="ANEXAR EVIDÊNCIAS">
            <Grid
              gridCols="6fr 3fr"
              gridGap={`0 ${SPACING.spacing10}`}
              margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
            >
              <InputFile
                onChange={(files) => {
                  const twoGigaBytes = 17179869184

                  if (files[0].size >= twoGigaBytes) {
                    showModal({
                      hideButtonCancel: true,
                      message:
                        'O arquivo anexado não pode ter tamanho maior que 2GB',
                      titleModal: 'Atenção',
                      txtButtonConfirm: 'OK',
                      type: 'alert'
                    })
                    return
                  }
                  handleChangeFile(files)
                }}
                renderInput={false}
                required
              />
              {arquivosSelecionados.length > 0 && (
                <Input
                  value={searchFile}
                  label="Pesquisa Geral"
                  placeholder="Pesquisar"
                  onChange={(e) => setSearchFile(e.target.value)}
                  inputIcon={<MagnifyingGlassIcon />}
                />
              )}
            </Grid>
            {arquivosSelecionados.length > 0 && (
              <Grid
                gridCols="12fr"
                gridGap={`0 ${SPACING.spacing10}`}
                margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
              >
                <AttachedFiles
                  tableData={handleFilterFilesTable()}
                  handleDeleteFile={handleFileToDelete}
                />
              </Grid>
            )}
          </SimpleCollapse>
        )}

        <Row justifyContent="flex-end" marginTop={SPACING.spacing20}>
          <Button
            text="Salvar e Finalizar"
            type="submit"
            disabled={handleDisabledSalvarButton()}
          />
          <Button
            text="Voltar"
            variantButton="text"
            marginLeft={SPACING.spacing20}
            marginRight={SPACING.spacing20}
            onClick={() => setTab(0)}
          />
          <Button
            text="ENVIAR E-MAIL"
            variantButton="outlined"
            onClick={enviarEmail}
          />
        </Row>
      </Form>
      <SuccessModal
        message={substituteErrorMsg}
        open={isError}
        type="error"
        handleConfirm={toggleError}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
      <SuccessModal
        message={successMsg}
        open={isSuccess}
        type="sucess"
        handleConfirm={() => setSuccess(false)}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
    </>
  )
}
